import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../services/api';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Kérlek add meg az email címed');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Kérlek adj meg egy érvényes email címet');
      return;
    }

    setLoading(true);

    try {
      const response = await auth.forgotPassword(email);
      setMessage(response.data.message || 'Ha a megadott email cím regisztrálva van, küldtünk egy jelszó visszaállító linket.');
      setEmail(''); // Clear input
    } catch (err) {
      console.error('Forgot password error:', err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Hiba történt. Kérlek próbáld újra később.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1>Elfelejtett jelszó</h1>
          <p className="auth-subtitle">
            Add meg az email címedet és küldünk egy linket a jelszó visszaállításához.
          </p>

          {error && <div className="alert alert-error">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email cím</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="pelda@email.com"
                disabled={loading}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'Küldés...' : 'Jelszó visszaállító link küldése'}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/login" className="auth-link">
              ← Vissza a bejelentkezéshez
            </Link>
          </div>

          <div className="auth-divider">
            <span>vagy</span>
          </div>

          <div className="auth-links">
            <p>
              Nincs még fiókod?{' '}
              <Link to="/register" className="auth-link-highlight">
                Regisztrálj itt
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
